import { auth } from '@/state/auth'
import axios from 'axios'
import { produce } from 'immer'
import { create } from 'zustand'
import type { UserMeResp } from '../../functions/api/user/me'

type UserState = {
  user: UserMeResp['user'] | null
  quota: UserMeResp['quota'] | null
  loading: boolean
  minusQuota(): void
  fetch(): Promise<void>
  reset(): void
}

export const useUserState = create<UserState>(set => ({
  user: null,
  quota: null,
  loading: false,

  fetch: async () => {
    set({ loading: true })
    try {
      const { data } = await auth(token =>
        axios.get<UserMeResp>('/api/user/me', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
      )
      set({
        user: data.user,
        quota: data.quota,
      })
    }
    catch (e) {
      console.error(e)
      set({ user: null })
    }
    finally {
      set({ loading: false })
    }
  },

  minusQuota: () => {
    set(produce((s: UserState) => {
      if (s.quota) {
        s.quota.remaining--
      }
    }))
  },

  reset: () => {
    set({
      user: null,
      loading: false,
    })
  },
}))
